var onlyVisibleWithJsElements = document.getElementsByClassName('wco_show_only_with_js');
for(var i = 0; i < onlyVisibleWithJsElements.length; i++)
{
    var currentItem = onlyVisibleWithJsElements.item(0);
    currentItem.className = currentItem.className.replace('wco_show_only_with_js', '');
}
